import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-indent-decrease",
  "use": "format-indent-decrease-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-indent-decrease\"><path fill-rule=\"evenodd\" d=\"M21 17v-2H11v2h10ZM7 16V8l-4 4 4 4Zm14 5v-2H3v2h18ZM3 5h18V3H3v2Zm18 4V7H11v2h10Zm0 4v-2H11v2h10Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol